/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Phase_FinalizeInputs */

const en_directory_submit_enrich_phase_finalize = /** @type {(inputs: Directory_Submit_Enrich_Phase_FinalizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalize`)
};

const zh_directory_submit_enrich_phase_finalize = /** @type {(inputs: Directory_Submit_Enrich_Phase_FinalizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整合`)
};

/**
* | output |
* | --- |
* | "Finalize" |
*
* @param {Directory_Submit_Enrich_Phase_FinalizeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_phase_finalize = /** @type {((inputs?: Directory_Submit_Enrich_Phase_FinalizeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Phase_FinalizeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_phase_finalize(inputs)
	return zh_directory_submit_enrich_phase_finalize(inputs)
});
export { directory_submit_enrich_phase_finalize as "directory.submit.enrich.phase.finalize" }